import config from '../config';
import { datadogRum } from '@datadog/browser-rum';
import { datadogTags } from './datadogConstants';
import { datadogLogs } from '@datadog/browser-logs';

export function initializeDatadogRum(): void {
  if (!datadogRum.getInitConfiguration()) {
    const { datadogRumClientToken, datadogEnv } = config;

    const isProduction = datadogEnv === 'production';

    if (isProduction) {
      try {
        datadogRum.init({
          applicationId: '372961c0-5714-40d3-a859-92dce6a6562c',
          clientToken: datadogRumClientToken,
          site: 'datadoghq.eu',
          service: 'cato',
          env: datadogEnv,
          sessionSampleRate: 100,
          sessionReplaySampleRate: 20,
          trackUserInteractions: true,
          trackResources: true,
          trackLongTasks: true,
          defaultPrivacyLevel: 'mask-user-input',
          allowedTracingUrls: [config.catoApiUrl, config.emailApiUrl, config.chatApiUrl].filter(
            (url): url is string => Boolean(url)
          ),
          traceSampleRate: 100
        });

        datadogRum.setGlobalContext({
          ...datadogRum.getGlobalContext(),
          ...datadogTags
        });

        datadogRum.startSessionReplayRecording();
      } catch (e) {
        throw new Error(e instanceof Error ? e.message : String(e));
      }
    }
  }

  // Set RUM user from Amazon Connect agent regardless of who initialized RUM
  try {
    connect.agent(function (agent) {
      const username = agent.getConfiguration().username;
      if (username) {
        datadogRum.setUser({
          email: username
        });
      }
    });
  } catch (e) {
    datadogLogs.logger.warn("Could not set user for Datadog RUM");
  }
}